export default __webpack_public_path__ + "static/media/11.b3ca16c9.jpg";